module.exports = "/images/sun.svg?e09195910663ae7a8d3c32f066057b79";